import type { PropsWithChildren } from 'react'

/** Responsive card grid shared by the asset-library pages. */
export const CardGrid = ({ children }: PropsWithChildren) => (
  <div className="grid gap-2 grid-cols-[repeat(auto-fill,minmax(280px,1fr))]">
    {children}
  </div>
)
